import {createContext} from 'react';

export const SelectedYear = createContext<string>('');
